/* Hygiene Hub Crew portal core — /pages/crew (rebuild, 9 Sep 2026). Increment 2.
   Read dashboard + render pipeline + data. Exposes window.HHCrew for hh-crew-actions.js.
   Appstle Storefront API over the App Proxy (same-origin, authed by customer login).
   No framework, ES2019. Money/dates always come from the contract. */
(function () {
  var CTX = window.HHCrew = window.HHCrew || {};
  if (CTX.booted) return; CTX.booted = true;

  var API = '/apps/subscriptions/cp/api/';
  var CFG = window.HH_CREW_CFG || {};
  var TOKEN = CFG.customerId != null ? String(CFG.customerId) : '';
  var app = document.getElementById('hh-crew-app');
  if (!app) return;
  var STATE = { f: null, upcoming: [], plans: null, busy: false };

  document.addEventListener('AppstleSubscription:CustomerPortal:ReadyToEmbed', function (e) {
    try { e.preventDefault && e.preventDefault(); e.stopImmediatePropagation && e.stopImmediatePropagation(); } catch (x) {}
  }, true);

  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(amount, cc) {
    var n = parseFloat(amount); if (isNaN(n)) return '';
    return (cc && cc !== 'AUD' ? '' : '$') + n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + (cc && cc !== 'AUD' ? ' ' + cc : '');
  }
  function num(m) { return m && m.amount != null ? parseFloat(m.amount) : (m != null ? parseFloat(m) : 0); }
  function q(path) { return API + path + (path.indexOf('?') >= 0 ? '&' : '?') + 'token=' + encodeURIComponent(TOKEN); }
  function fetchJSON(path) {
    return fetch(q(path), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw { status: r.status, path: path }; return r.json(); });
  }
  function putAPI(path) {
    return fetch(q(path), { method: 'PUT', credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.text().then(function (t) { var j = null; try { j = t ? JSON.parse(t) : null; } catch (e) {} if (!r.ok) throw { status: r.status, body: j || t }; return j; }); });
  }
  function postAPI(path, body) {
    return fetch(q(path), { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: body != null ? JSON.stringify(body) : null })
      .then(function (r) { return r.text().then(function (t) { var j = null; try { j = t ? JSON.parse(t) : null; } catch (e) {} if (!r.ok) throw { status: r.status, body: j || t }; return j; }); });
  }
  function fmtDate(iso) { if (!iso) return ''; var d = new Date(iso); if (isNaN(d)) return ''; return d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' }); }
  function fmtLong(iso) { if (!iso) return ''; var d = new Date(iso); if (isNaN(d)) return ''; return d.toLocaleDateString('en-AU', { weekday: 'long', day: 'numeric', month: 'long' }); }
  function daysUntil(iso) { if (!iso) return null; var d = new Date(iso); if (isNaN(d)) return null; var ms = d.setHours(0, 0, 0, 0) - new Date().setHours(0, 0, 0, 0); return Math.round(ms / 86400000); }
  function inWords(days) {
    if (days == null) return '';
    if (days < 0) return 'now due'; if (days === 0) return 'today'; if (days === 1) return 'tomorrow';
    if (days < 14) return 'in ' + days + ' days'; if (days < 60) return 'in ' + Math.round(days / 7) + ' weeks';
    return 'in ' + Math.round(days / 30) + ' months';
  }
  function cadence(intervalCount, interval) {
    if (!interval) return '';
    var unit = String(interval).toLowerCase().replace(/s$/, '');
    var plural = intervalCount === 1 ? unit : unit + 's';
    return intervalCount === 1 ? ('every ' + unit) : ('every ' + intervalCount + ' ' + plural);
  }
  function shiftISO(iso, days) { var d = new Date(iso); if (isNaN(d)) d = new Date(); d.setDate(d.getDate() + days); return d.toISOString().replace(/\.\d{3}Z$/, 'Z'); }
  function dateToISO(ymdStr, refIso) {
    var ref = new Date(refIso); if (isNaN(ref)) ref = new Date();
    var p = String(ymdStr).split('-');
    var d = new Date(Date.UTC(+p[0], (+p[1]) - 1, +p[2], ref.getUTCHours(), ref.getUTCMinutes(), 0));
    return d.toISOString().replace(/\.\d{3}Z$/, 'Z');
  }
  function ymd(iso) { var d = new Date(iso); if (isNaN(d)) d = new Date(); return d.toISOString().slice(0, 10); }

  function normContract(node) {
    var lines = ((node.lines && node.lines.nodes) || []).map(function (l) {
      var qty = l.quantity || 0; var lineTotal = num(l.lineDiscountedPrice);
      return { id: l.id, variantId: l.variantId, productId: l.productId, sku: l.sku, title: l.title, size: l.variantTitle, qty: qty,
        image: l.variantImage, perBox: qty ? lineTotal / qty : num(l.currentPrice), planPerBox: num(l.currentPrice), lineTotal: lineTotal,
        plan: l.sellingPlanName || '', planId: l.sellingPlanId, cc: (l.lineDiscountedPrice && l.lineDiscountedPrice.currencyCode) || 'AUD' };
    });
    var total = lines.reduce(function (s, l) { return s + l.lineTotal; }, 0);
    var boxes = lines.reduce(function (s, l) { return s + l.qty; }, 0);
    return { id: node.id, idNum: (String(node.id).match(/(\d+)$/) || [])[1], status: String(node.status || '').toUpperCase(),
      next: node.nextBillingDate, interval: node.billingPolicy && node.billingPolicy.interval,
      intervalCount: node.billingPolicy && node.billingPolicy.intervalCount, deliveryPrice: num(node.deliveryPrice),
      lastPaymentStatus: node.lastPaymentStatus, payment: node.customerPaymentMethod, lines: lines, total: total, boxes: boxes, cc: (lines[0] && lines[0].cc) || 'AUD' };
  }
  function paymentLabel(pm) {
    if (!pm || !pm.instrument) return 'On file';
    var t = pm.instrument.__typename || '';
    if (t === 'CustomerShopPayAgreement') return 'Shop Pay';
    if (t === 'CustomerCreditCard') return (pm.instrument.brand || 'Card') + ' ' + (pm.instrument.lastDigits ? '•••• ' + pm.instrument.lastDigits : '');
    if (t === 'CustomerPaypalBillingAgreement') return 'PayPal';
    return 'On file';
  }
  function earliest(list) { return list.slice().sort(function (a, b) { return new Date(a.next || 0) - new Date(b.next || 0); })[0]; }
  function pickFocus(contracts) {
    var active = contracts.filter(function (c) { return c.status === 'ACTIVE'; });
    var paused = contracts.filter(function (c) { return c.status === 'PAUSED'; });
    var failed = active.filter(function (c) { return c.lastPaymentStatus && /fail|error|declin/i.test(c.lastPaymentStatus); });
    if (failed.length) return { state: 'failed', focus: earliest(failed), rest: contracts };
    if (active.length) return { state: 'active', focus: earliest(active), rest: contracts };
    if (paused.length) return { state: 'paused', focus: earliest(paused), rest: contracts };
    return { state: 'cancelled', focus: null, rest: contracts };
  }
  function nextOrder() { return (STATE.upcoming || []).slice().sort(function (a, b) { return new Date(a.billingDate || 0) - new Date(b.billingDate || 0); })[0] || null; }
  function cid() { return STATE.f && STATE.f.focus && STATE.f.focus.idNum; }

  function skeleton() {
    app.innerHTML = '';
    var s = el('div', 'hhx-card hhx-skel');
    s.innerHTML = '<div class="hhx-sk hhx-sk--lg"></div><div class="hhx-sk"></div><div class="hhx-sk"></div><div class="hhx-sk hhx-sk--btn"></div>';
    app.appendChild(s);
  }
  function errorCard(retry) {
    app.innerHTML = '';
    var c = el('div', 'hhx-card hhx-card--err');
    c.innerHTML = '<p class="hhx-err-t">Couldn’t load your next box</p><p class="hhx-err-b">Your rewards, past orders and perks are below. Give this another go in a moment.</p>';
    var b = el('button', 'hhx-btn hhx-btn--ghost', 'Retry'); b.type = 'button'; b.addEventListener('click', retry);
    c.appendChild(b); app.appendChild(c);
  }
  function prettyName(l) { return (l.title || 'Grip-X').replace(/^\[TEST[^\]]*\]\s*/i, '').replace(/\s*—.*$/, '') || 'Grip-X'; }
  function contentsRows(c) {
    return c.lines.map(function (l) {
      return '<div class="hhx-line"><div class="hhx-line-l"><span class="hhx-line-name">' + esc(prettyName(l)) + '</span>' +
        '<span class="hhx-line-sub">' + esc(l.size || '') + (l.size ? ' · ' : '') + l.qty + (l.qty === 1 ? ' box' : ' boxes') + '</span></div>' +
        '<div class="hhx-line-r">' + money(l.perBox, l.cc) + '<span>/box</span></div></div>';
    }).join('');
  }
  function actionsHTML(f) {
    var no = nextOrder(); var skipped = no && /skip/i.test(String(no.status || ''));
    var btns = [];
    if (f.state === 'active' || f.state === 'failed') {
      btns.push('<button type="button" class="hhx-act" data-act="delay">Delay</button>');
      if (skipped) btns.push('<button type="button" class="hhx-act hhx-act--on" data-act="unskip">Unskip this box</button>');
      else btns.push('<button type="button" class="hhx-act" data-act="skip">Skip this box</button>');
      btns.push('<button type="button" class="hhx-act" data-act="size">Change size</button>');
      btns.push('<button type="button" class="hhx-act" data-act="qty">Change quantity</button>');
      btns.push('<button type="button" class="hhx-act" data-act="freq">Change frequency</button>');
      btns.push('<button type="button" class="hhx-act" data-act="pause">Pause</button>');
      btns.push('<button type="button" class="hhx-act hhx-act--send" data-act="sendnow">Send now</button>');
    } else if (f.state === 'paused') {
      btns.push('<button type="button" class="hhx-act hhx-act--resume" data-act="resume">Resume deliveries</button>');
      btns.push('<button type="button" class="hhx-act" data-act="freq">Change frequency</button>');
    }
    if (!btns.length) return '';
    return '<div class="hhx-actions">' + btns.join('') + '</div>';
  }
  function nextBoxCard(f) {
    var c = f.focus;
    var card = el('section', 'hhx-card hhx-next'); card.id = 'next';
    if (f.state === 'cancelled' || !c) {
      card.innerHTML = '<p class="hhx-eyebrow">Set &amp; Forget</p><h2 class="hhx-h2">You’re not on Set &amp; Forget right now</h2>' +
        '<p class="hhx-muted">Put your Grip-X on autopilot — 18% off every delivery, free shipping on your first order, and a free box every 30. Cancel or skip any time.</p>' +
        '<a class="hhx-btn hhx-btn--green" href="/products/' + esc(CFG.gripHandle || 'heavy-duty-black-nitrile-gloves-50-pack') + '">Start Set &amp; Forget</a>';
      return card;
    }
    var no = nextOrder(); var skipped = no && /skip/i.test(String(no.status || ''));
    var days = daysUntil(c.next);
    var head = '<div class="hhx-next-head"><div><p class="hhx-eyebrow">Your next box</p>' +
      '<p class="hhx-date">' + esc(fmtDate(c.next)) + '</p><p class="hhx-date-sub">' + esc(inWords(days)) + '</p></div>' +
      '<span class="hhx-chip ' + (f.state === 'paused' ? 'hhx-chip--amber' : f.state === 'failed' ? 'hhx-chip--red' : 'hhx-chip--green') + '">' +
      (f.state === 'paused' ? 'Paused' : f.state === 'failed' ? 'Payment failed' : 'Active') + '</span></div>' +
      '<p class="hhx-cad">Sent to you ' + esc(cadence(c.intervalCount, c.interval)) + '</p>';
    var contents = '<div class="hhx-contents">' + contentsRows(c) +
      '<div class="hhx-total"><span>Total</span><span>' + money(c.total, c.cc) + (c.deliveryPrice ? '' : ' <em>+ free shipping</em>') + '</span></div>' +
      '<p class="hhx-renew">Renews at ' + money(c.total, c.cc) + ' — same price, every time.</p></div>';
    var failedStrip = f.state === 'failed' ? '<div class="hhx-alert">We couldn’t take payment for this box. Update your payment method to keep it on track.</div>' : '';
    var pausedStrip = f.state === 'paused' ? '<div class="hhx-alert hhx-alert--amber">This Set &amp; Forget is paused. Resume it whenever you’re ready.</div>' : '';
    var skipStrip = skipped ? '<div class="hhx-alert hhx-alert--amber">This box is skipped — you won’t be billed on ' + esc(fmtDate(no.billingDate)) + '. Unskip it any time.</div>' : '';
    var meta = '<div class="hhx-meta"><div><span class="hhx-meta-k">Shipping to</span><span class="hhx-meta-v">' + esc(CFG.address || 'Your saved address') + '</span></div>' +
      '<div><span class="hhx-meta-k">Paying with</span><span class="hhx-meta-v">' + esc(paymentLabel(c.payment)) + '</span></div></div>';
    var soon = '';
    var futures = (STATE.upcoming || []).filter(function (u) { return u.billingDate && new Date(u.billingDate) > new Date(c.next); }).slice(0, 3);
    if (futures.length) {
      soon = '<details class="hhx-soon"><summary>Also coming up</summary>' + futures.map(function (u) {
        return '<div class="hhx-soon-row"><span>' + esc(fmtDate(u.billingDate)) + '</span><span>' + esc(inWords(daysUntil(u.billingDate))) + '</span></div>';
      }).join('') + '</details>';
    }
    card.innerHTML = failedStrip + pausedStrip + skipStrip + head + contents + actionsHTML(f) + meta + soon;
    return card;
  }
  function enhanceRewards(f) {
    try {
      var track = document.querySelector('[data-hhx-track]'); if (!track) return;
      var per = parseInt(track.getAttribute('data-per'), 10) || (CFG.boxesPerReward || 30);
      var into = parseInt(track.getAttribute('data-into'), 10) || 0;
      var pips = track.querySelectorAll('.hhx-pip');
      for (var i = 0; i < pips.length; i++) pips[i].classList.remove('is-proj');
      if (!f || !f.focus || (f.state !== 'active' && f.state !== 'failed')) return;
      var add = f.focus.boxes || 0; var proj = Math.min(into + add, per);
      for (var j = into; j < proj; j++) if (pips[j]) pips[j].classList.add('is-proj');
      var take = document.querySelector('[data-hhx-take]');
      if (take && add > 0) {
        if (proj >= per) take.innerHTML = 'This box earns your next <b>free box</b> 🎁';
        else take.innerHTML = 'This box takes you to <b>' + proj + ' / ' + per + '</b> — ' + (per - proj) + ' to go.';
      }
    } catch (e) {}
  }
  function wireBreakLinks(f) {
    var pause = document.querySelector('[data-hhx-pause]');
    if (pause && !pause.__wired) {
      pause.__wired = true;
      pause.addEventListener('click', function (e) {
        e.preventDefault();
        var act = CTX.act || {};
        if (STATE.f && STATE.f.state === 'paused') { if (act.resume) act.resume(); } else if (act.pause) act.pause();
      });
    }
    if (pause) pause.textContent = (f && f.state === 'paused') ? 'Resume Set & Forget' : 'Pause Set & Forget';
  }
  function render() {
    var f = STATE.f;
    app.innerHTML = '';
    app.appendChild(nextBoxCard(f));
    enhanceRewards(f); wireBreakLinks(f);
    window.dispatchEvent(new CustomEvent('hh-crew:rendered', { detail: { state: f.state } }));
  }
  function loadCore() {
    return Promise.all([
      fetchJSON('subscription-customers'),
      fetchJSON('subscription-groups/all-selling-plans').catch(function () { return null; })
    ]).then(function (res) {
      var cust = res[0]; STATE.plans = res[1] || STATE.plans;
      var nodes = (cust && cust.subscriptionContracts && cust.subscriptionContracts.nodes) || [];
      STATE.f = pickFocus(nodes.map(normContract));
      var idNum = STATE.f.focus && STATE.f.focus.idNum;
      return (idNum ? fetchJSON('subscription-billing-attempts/top-orders?contractId=' + idNum).catch(function () { return []; }) : Promise.resolve([]))
        .then(function (up) { STATE.upcoming = up || []; });
    });
  }
  function boot() { skeleton(); loadCore().then(function () { render(); renderPast(STATE.f); }).catch(function () { errorCard(boot); }); }
  function refresh() { return loadCore().then(function () { render(); }); }
  function renderPast(f) {
    var host = document.getElementById('hh-crew-orders');
    if (!host || !f.focus || !f.focus.idNum) return;
    fetchJSON('subscription-billing-attempts/past-orders?contractId=' + f.focus.idNum).then(function (list) {
      if (!Array.isArray(list) || !list.length) { host.innerHTML = '<p class="hhx-muted">No past Set &amp; Forget boxes yet.</p>'; return; }
      host.innerHTML = list.slice(0, 8).map(function (o) {
        var boxes = (o.variantList || []).reduce(function (s, v) { return s + (v.quantity || 0); }, 0);
        return '<div class="hhx-order"><div><span class="hhx-order-name">' + esc(o.orderName || 'Order') + '</span>' +
          '<span class="hhx-order-sub">' + esc(fmtDate(o.billingDate || o.orderProcessedAt)) + (boxes ? ' · ' + boxes + ' boxes' : '') + '</span></div>' +
          '<div class="hhx-order-r">' + (o.orderAmount != null ? money(o.orderAmount, 'AUD') : '') +
          (o.orderDisplayFulfillmentStatus ? '<span class="hhx-order-fs">' + esc(String(o.orderDisplayFulfillmentStatus).toLowerCase()) + '</span>' : '') + '</div></div>';
      }).join('');
    }).catch(function () { host.innerHTML = '<p class="hhx-muted">Couldn’t load past boxes.</p>'; });
  }

  app.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.hhx-act[data-act]');
    if (!b) return; e.preventDefault();
    var fn = CTX.act && CTX.act[b.getAttribute('data-act')];
    if (fn) fn();
  });

  /* shared context for hh-crew-actions.js */
  CTX.API = API; CTX.CFG = CFG; CTX.STATE = STATE; CTX.el = el; CTX.esc = esc; CTX.money = money; CTX.num = num;
  CTX.q = q; CTX.putAPI = putAPI; CTX.postAPI = postAPI; CTX.fetchJSON = fetchJSON; CTX.fmtDate = fmtDate; CTX.fmtLong = fmtLong;
  CTX.shiftISO = shiftISO; CTX.dateToISO = dateToISO; CTX.ymd = ymd; CTX.paymentLabel = paymentLabel; CTX.prettyName = prettyName;
  CTX.nextOrder = nextOrder; CTX.cid = cid; CTX.refresh = refresh;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();